import React, { useEffect, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from 'swiper';

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper";

import Header from "../components/Header";
import Footer from "../components/Footer";
import AOS from "aos";
import { Link } from "react-router-dom";

//translate
import { useTranslation } from 'react-i18next';
import i18n from "../i18n";

const Index = () => {

    const { t } = useTranslation();

    document.title = i18n.language === "en" ? "Kasab Kablo | HIGH QUALITY IS OUR OBLIGATION!" : i18n.language === "tr" ? "Kasab Kablo | YÜKSEK KALİTE TAAHHÜDÜMÜZDÜR!" : "Kasab Kablo";
    document.getElementsByTagName("META")[2].content = i18n.language === "en" ? "Kasab Kablo Elektrik Sanayi ve Ticaret Limited Şirketi, aims to establish quality values by providing high quality products with high service quality for its business partners and customers." : i18n.language === "tr" ? "Kasab Kablo Elektrik Sanayi ve Ticaret Limited Şirketi, iş ortakları ve müşterileri için yüksek kaliteli ürünlerini yüksek hizmet kalitesiyle sağlayarak kaliteli değerler oluşturmayı hedeflemektedir." : "Kasab Kablo Elektrik Sanayi ve Ticaret Limited Şirketi, iş ortakları ve müşterileri için yüksek kaliteli ürünlerini yüksek hizmet kalitesiyle sağlayarak kaliteli değerler oluşturmayı hedeflemektedir.";

    SwiperCore.use([Autoplay])

    //const [modalIsOpen, setModalIsOpen] = useState(true);

    useEffect(() => {
        AOS.init({
            duration: 2000
        });
    }, []);

    return (
        <>
            {/*  {
                modalIsOpen &&
                <div id="modal" onClick={() => setModalIsOpen(false)}>
                    <div className="modalContent">
                        <button onClick={() => setModalIsOpen(false)}>X</button>
                        <img src="/assets/img/fuar.png" alt="" />
                    </div>
                </div>
            } */}
            <Header />
            <section id="hero">
                <Swiper
                    pagination={{
                        type: "progressbar",
                    }}
                    navigation={true}
                    modules={[Pagination, Navigation]}
                    className="mySwiper"
                    loop={true}
                    autoplay={{
                        delay: 2000,
                    }}
                >
                    <SwiperSlide>
                        <div className="carousel-inner" role="listbox">
                            {/*   "titleBlack": "Hoşgeldiniz!",
                            "titleRed": "KASAB KABLO!",
                            "description": "Minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat tarad limino ata",
                            "button": "Keşfedin" */}
                            <div className="carousel-item active first-item" style={{ backgroundImage: "url(/assets/img/slide/slide-1.jpg)" }}>
                                <div className="carousel-container">
                                    <div className="carousel-content">
                                        <h2 className="animate__animated animate__fadeInDown">{i18n.language === "en" ? t("slide.1.titleBlack") : t("slide.1.titleRed")} <span>{i18n.language === "en" ? t("slide.1.titleRed") : t("slide.1.titleBlack")}</span></h2>
                                        <p className="animate__animated animate__fadeInUp">{t("slide.1.description")}</p>
                                        <a href="#main" className="btn-get-started animate__animated animate__fadeInUp">{t("slide.1.button")}</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="carousel-inner" role="listbox">

                            <div className="carousel-item active" style={{ backgroundImage: "url(/assets/img/slide/slide-6.png)" }}>
                            </div>

                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="carousel-inner" role="listbox">

                            <div className="carousel-item active" style={{ backgroundImage: "url(/assets/img/slide/slide-2.png)" }}>
                            </div>

                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="carousel-inner" role="listbox">

                            <div className="carousel-item active" style={{ backgroundImage: "url(/assets/img/slide/slide-3.png)" }}>
                            </div>

                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="carousel-inner" role="listbox">

                            <div className="carousel-item active" style={{ backgroundImage: "url(/assets/img/slide/slide-4.png)" }}>
                            </div>

                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="carousel-inner" role="listbox">

                            <div className="carousel-item active" style={{ backgroundImage: "url(/assets/img/slide/slide-5.jpg)" }}>
                            </div>

                        </div>
                    </SwiperSlide>
                </Swiper>
            </section>


            <main id="main">

                {/* <!-- ======= Featured Section ======= --> */}
                {/* <div className="container">
                    <div class="row">
                        <div className="col-md-6 mb-3">
                            <iframe src={`https://${i18n.language === "en" ? "uk" : "tr"}.widgets.investing.com/live-currency-cross-rates?theme=lightTheme&pairs=66,18`} width="100%" height="100%" frameborder="0" allowtransparency="true" marginwidth="0" marginheight="0"></iframe>
                        </div>
                        <div className="col-md-6 mb-3">
                            <iframe src={`https://${i18n.language === "en" ? "uk" : "tr"}.widgets.investing.com/live-currency-cross-rates?theme=lightTheme&pairs=49768,959211`} width="100%" height="100%" frameborder="0" allowtransparency="true" marginwidth="0" marginheight="0"></iframe>
                        </div>
                    </div>
                </div> */}

                <div className="container my-5">
                    <Link to="/certificates">
                        <h2 className="qualitySlideTitle">&raquo; {t("links.Certificates")}</h2>
                    </Link>
                    <Swiper
                        spaceBetween={30}
                        loop={true}
                        autoplay={{
                            delay: 1500,
                        }}
                        breakpoints={{
                            0: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 3,
                            },
                            1200: {
                                slidesPerView: 5,
                            },
                        }}
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <Link to="/certificates">
                                <img className="qualitySlide" src="/assets/img/quality/1.jpg" alt="" />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/certificates">
                                <img className="qualitySlide" src="/assets/img/quality/2.jpg" alt="" />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/certificates">
                                <img className="qualitySlide" src="/assets/img/quality/3.jpg" alt="" />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/certificates">
                                <img className="qualitySlide" src="/assets/img/quality/4.jpg" alt="" />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/certificates">
                                <img className="qualitySlide" src="/assets/img/quality/5.jpg" alt="" />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/certificates">
                                <img className="qualitySlide" src="/assets/img/quality/6.jpg" alt="" />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/certificates">
                                <img className="qualitySlide" src="/assets/img/quality/7.jpg" alt="" />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/certificates">
                                <img className="qualitySlide" src="/assets/img/quality/8.jpg" alt="" />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/certificates">
                                <img className="qualitySlide" src="/assets/img/quality/9.jpg" alt="" />
                            </Link>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Link to="/certificates">
                                <img className="qualitySlide" src="/assets/img/quality/10.jpg" alt="" />
                            </Link>
                        </SwiperSlide>
                    </Swiper>
                </div>

                <section id="featured" className="featured">

                    <div className="container">

                        <div className="row">
                            <div className="col-lg-4">
                                <div className="icon-box" data-aos="flip-down">
                                    <i className="bi bi-award"></i>
                                    <h3><Link to="">{t("skills.1.title")}</Link></h3>
                                    <p>{t("skills.1.description")}</p>
                                </div>
                            </div>
                            <div className="col-lg-4 mt-4 mt-lg-0">
                                <div className="icon-box" data-aos="flip-down">
                                    <i className="bi bi-collection"></i>
                                    <h3><Link to="">{t("skills.2.title")}</Link></h3>
                                    <p>{t("skills.2.description")}</p>
                                </div>
                            </div>
                            <div className="col-lg-4 mt-4 mt-lg-0">
                                <div className="icon-box" data-aos="flip-down">
                                    <i className="bi bi-people"></i>
                                    <h3><Link to="">{t("skills.3.title")}</Link></h3>
                                    <p>{t("skills.3.description")}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </section > {/* <!-- End Featured Section --> */}

                {/* <!-- ======= About Section ======= --> */}
                <section id="about" className="about">
                    <div className="container" data-aos="fade-right">

                        <div className="row">
                            <div className="col-lg-6 pt-4 pt-lg-0 content">
                                <h3>{t("posts.1.title")}</h3>
                                <p>
                                    {t("posts.1.description")}
                                </p>
                                <Link className="mb-4" to="/about">{t("posts.readMore")} &raquo;</Link>
                            </div>
                            <div className="col-lg-6 right-img">
                                <img src="/assets/img/about.jpg" className="img-fluid" alt="" />
                            </div>
                        </div>

                    </div>

                    <div className='container'>
                        <hr />
                    </div>

                    <div className="container" data-aos="fade-left">

                        <div className="row">
                            <div className="col-lg-6 left-img">
                                <img src="/assets/img/factory.jpg" className="img-fluid" alt="" />
                            </div>
                            <div className="col-lg-6 pt-4 pt-lg-0 content">
                                <h3>{t("posts.2.title")}</h3>
                                <p>
                                    {t("posts.2.description")}
                                </p>
                                <Link className="mb-4" to="/about">{t("posts.readMore")} &raquo;</Link>
                            </div>
                        </div>

                    </div>

                    <div className='container'>
                        <hr />
                    </div>

                    <div className="container" data-aos="fade-right">

                        <div className="row">
                            <div className="col-lg-6 pt-4 pt-lg-0 content">
                                <h3>{t("posts.3.title")}</h3>
                                <p>
                                    {t("posts.3.description")}
                                </p>
                                {/*  <ul>
                                    <li><i className="bi bi-check-circle"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat.</li>
                                    <li><i className="bi bi-check-circle"></i> Duis aute irure dolor in reprehenderit in voluptate velit.</li>
                                    <li><i className="bi bi-check-circle"></i> Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</li>
                                </ul> */}
                                <Link className="mb-4" to="/about">{t("posts.readMore")} &raquo;</Link>
                            </div>
                            <div className="col-lg-6 right-img">
                                <img src="/assets/img/kalite-mockup.jpg" className="img-fluid" alt="" />
                            </div>
                        </div>

                    </div>
                </section>{/* <!-- End About Section --> */}

                {/* <!-- ======= Services Section ======= --> */}
                <section id="services" className="services">
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-3 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
                                <div className="icon-box" data-aos="flip-up">
                                    <div className="icon"><i className="bi bi-shield-check"></i></div>
                                    <h4><Link to="">{t("features.1.title")}</Link></h4>
                                    <p>{t("features.1.description")}</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
                                <div className="icon-box" data-aos="flip-up">
                                    <div className="icon"><i className="bi bi-clock-history"></i></div>
                                    <h4><Link to="">{t("features.2.title")}</Link></h4>
                                    <p>{t("features.2.description")}</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
                                <div className="icon-box" data-aos="flip-up">
                                    <div className="icon"><i className="bi bi-emoji-smile"></i></div>
                                    <h4><Link to="">{t("features.3.title")}</Link></h4>
                                    <p>{t("features.3.description")}</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 d-flex align-items-stretch mt-4 mt-lg-0">
                                <div className="icon-box" data-aos="flip-up">
                                    <div className="icon"><i className="bi bi-graph-up-arrow"></i></div>
                                    <h4><Link to="">{t("features.4.title")}</Link></h4>
                                    <p>{t("features.4.description")}</p>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>{/* <!-- End Services Section --> */}

            </main > {/* <!-- End #main --> */}
            < Footer />
        </>
    )
};

export default Index;